// extracted by mini-css-extract-plugin
export default {"title":"Hci5s"};